<script lang="ts">
	import type { LocalBusiness, Organization, WithContext } from "schema-dts";
	import { ZmsFb } from "@core/utils/ZmsFb.js";
	import { getGlobalSettings } from "../../contexts/getGlobalSettings.js";
	import { getStructuredDataScript } from "../../utils/getStructuredDataScript.js";
	import { email } from "../email.js";
	import { phoneNumber } from "../phoneNumber.js";

	const { WEB_URL } = getGlobalSettings();

	const phone = phoneNumber.replace(/\s+/gu, "");
	const orgId = `${WEB_URL}/#organization`;

	const organization: WithContext<Organization> = {
		"@context": "https://schema.org",
		"@type": "Organization",
		"@id": orgId,
		name: "ZM Servis Moravia s.r.o.",
		url: WEB_URL,
		logo: {
			"@type": "ImageObject",
			url: `${WEB_URL}/logo.png`,
			width: "149",
			height: "74",
		},
		telephone: phone,
		email,
		sameAs: [ZmsFb, "https://www.instagram.com/zmservismoravia/", "https://www.youtube.com/@zmservismoravias.r.o.2807"],
	};

	// Souřadnice ověřeny z Google Maps embedu v WhereYouCanFindUs.svelte
	const localBusiness: WithContext<LocalBusiness> = {
		"@context": "https://schema.org",
		"@type": "LocalBusiness",
		"@id": `${WEB_URL}/#localbusiness`,
		name: "ZM Servis Moravia s.r.o.",
		address: {
			"@type": "PostalAddress",
			streetAddress: "Lánská 298",
			addressLocality: "Třinec",
			postalCode: "73961",
			addressCountry: "CZ",
		},
		geo: {
			"@type": "GeoCoordinates",
			latitude: 49.6707004,
			longitude: 18.6406813,
		},
	};
	/* eslint-disable svelte/no-at-html-tags */
</script>

<svelte:head>
	{@html getStructuredDataScript(organization)}
	{@html getStructuredDataScript(localBusiness)}
</svelte:head>
